/*
 * @Author: cyerogy cyerogy@163.com
 * @Date: 2025-04-04 10:16:47
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-04 10:19:46
 * @FilePath: \projectorder\src\common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { deepCopy, validEmpty, openWindow, permission } from "@/utils/validate";
import { ElMessageBox } from 'element-plus';
export const totalCommon = {
  methods: {
    empty(value) {
      return validEmpty(value);
    },
    deepCopy(value) {
      return deepCopy(value);
    },
    loopData(callbackFunc, timeout = 5000) {
      return window.setInterval(() => {
        setTimeout(() => {
          callbackFunc()
        }, 0)
      }, timeout)
    },
    openWindow(url, pdata) {
      openWindow(url, pdata)
    },
    checkScreenWidth() {
      let bodyInfo = document.body.getBoundingClientRect();
      return bodyInfo.width > 2000
    },
    hasPermission(value) {
      return permission(value);
    },
    constName(value, list, keyName = 'value', labelName = 'label') {
      if (typeof value == 'undefined' || value === null) {
        return "";
      }
      let info = list.find((item) => {
        return value.toString() == item[keyName].toString();
      });
      if (!this.empty(info)) {
        return info[labelName];
      } else {
        return value;
      }
    },
    deleteInfo(info) {
      let { title, message, successCallback } = info;
      if (this.empty(title)) {
        title = "提醒"
      }
      if (this.empty(message)) {
        message = "是否删除已选中的数据？"
      }
      ElMessageBox.confirm(
        message,
        title,
        {
          customClass: "delet-dialog",
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          successCallback && successCallback()
        })
        .catch(() => {

        })
    },
    formateNumberValue(value) {
      return value;
    },
  },
}

